import { useContext } from "react";
import { LayoutContext } from "./context";

export const useLayoutProvider = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("No LayoutContext context was provided.");
  }
  return context;
};
